import { BaseModel } from "../abstracts/base.model";
import { ExamAnswerListSubjectModel } from "./exam-answer-list-subject.model";
import { ExamAnswerModel } from './exam-answer.model';

export class ExamAnswerListModel extends BaseModel {
    ExamAnswerListID: any;
    ExamBookletID: any;
    ExamAnswerListIndex: any;
    ExamAnswerListTitle: string
    NumberOfQuestion: number
    ExamAnswers: ExamAnswerModel[]


    //Soruların konuları ExamAnswerModel sınıfında bulunmaktadır. Kaydedildiğinde ExamAnswerModel ile kaydedilmektedir.
    //Bu alan sadece ön yüzde göstermek için kullanılmaktadır.
    ExamAnswerSubjects: ExamAnswerListSubjectModel[] = []
}